import moment from "moment";
import { LoadState } from "../../constants/enums";
import { defaultGateEntryItem } from "../gate-entry";
import { defaultPurchaseOrderItem } from "../purchase-order/purchase-order.state";
import {
  IGoodsReceivedNote,
  IGoodsReceivedNoteItem,
  IGoodsReceivedNoteState,
} from "./grn.types";

export const defaultGoodsReceivedNoteItem: IGoodsReceivedNoteItem = {
  ...defaultGateEntryItem,
};

export const defaultGoodsReceivedNote: IGoodsReceivedNote = {
  grn_uuid: null,
  gate_entry_uuid: null,
  gate_entry_no: null,
  origin_from: null,
  origin_from_uuid: null,
  origin_from_document_no: null,
  origin_from_document_date: null,
  grn_type: null,
  grn_date: moment().format("YYYY-MM-DD"),
  combined_grn_no: "",
  project_uuid: null,
  project_name: null,
  po_data: [],
  vehicle_no: null,
  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  billing_company_branch_state: null,
  vendor_uuid: "",
  vendor_name: "",
  vendor_email: "",
  vendor_phone_number: "",
  vendor_contact_name: "",
  registration_type: "",
  vendor_gstin: "",
  remark: null,
  invoice_items: [],
  attachments: [],
  invoice_no: "",
  status: "ACTIVE",
};

export const defaultGoodsReceivedNoteState: IGoodsReceivedNoteState = {
  goods_received_note_list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  single_goods_received_note: {
    data: defaultGoodsReceivedNote,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
